<template>
    <div>
        <el-page-header @back="goBack" content=""></el-page-header>
        <el-card shadow="never" class="aui-card--fill box-card">
            <div class="mod-demo__news">
<!--                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">-->
<!--                    <el-form-item>-->
<!--                        <el-input v-model="dataForm.title" placeholder="请输入残协名称或专职委员" clearable></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item>-->
<!--                        <el-button @click="getDataList()">查询</el-button>-->
<!--                    </el-form-item>-->
<!--                </el-form>-->

                <el-table v-if="dataForm.level !== 3" v-loading="dataListLoading" :data="dataList" border
                    @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                    style="width: 100%">
                    <el-table-column prop="area" label="地区" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.area !== '总计'" style="color: #6399ff; cursor: pointer" @click="changeLevel(scope.row)"> {{ scope.row.area }} </span>
                            <span v-else> {{ scope.row.area }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total" label="总计" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="finish" label="已调查" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="unfinish" label="未调查" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="progress" label="完成度" header-align="center" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.progress + '%' }}
                        </template>
                    </el-table-column>
                </el-table>

                <el-table v-else v-loading="dataListLoading" :data="dataList" border
                          @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                          style="width: 100%">
                    <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="handicappedXm" label="姓名" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="handicappedMobile" label="联系电话" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="cjInfo" label="残疾等级" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="taskStatus" label="是否完成" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taskStatus == '1'">未完成</span>
                            <span v-if="scope.row.taskStatus == '2'">已完成</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination v-if="dataForm.level === 3" :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                               layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                               @current-change="pageCurrentChangeHandle">
                </el-pagination>
                <!-- 查看详情-->
                <condition-detail v-if="OpenViewAssociation" ref="ViewAssociation"></condition-detail>
            </div>
        </el-card>
    </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import conditionDetail from './conditionDetail';
export default {
    mixins: [mixinViewModule],
    components: {
        conditionDetail,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/task/zhenResultList",
                getDataListIsPage: false,
                deleteURL: "/demo/news",
                deleteIsBatch: true,
                createdIsNeed: false,
            },
            daterange: null,
            dataForm: {
                taskId: '',
                title: "",
                startDate: "",
                endDate: "",
                zhen: '',
                cun: '',
                level: 1,
                area: JSON.parse(localStorage.getItem('org')).area || ''
            },
            OpenViewAssociation: false,
        };
    },
    watch: {
        daterange(val) {
            if (val == null) {
                this.dataForm.startDate = null;
                this.dataForm.endDate = null;
            } else {
                this.dataForm.startDate = val[0];
                this.dataForm.endDate = val[1];
            }
        },
    },
    created() {
        this.dataForm.taskId = this.$route.query.id
        this.dataForm.taskType = this.$route.query.taskType
        this.dataForm.level = 1
        this.query()
        if (!this.$route.query) return;

    },
    methods: {
        goBack() {
            if (this.dataForm.level !== 1) {
                this.dataForm.level -= 1
                this.mixinViewModuleOptions.getDataListIsPage = false
                if (this.dataForm.level === 2) {
                    this.mixinViewModuleOptions.getDataListURL = '/task/cunResultList'
                } else {
                    this.mixinViewModuleOptions.getDataListURL = '/task/zhenResultList'
                }
                this.query()
                return
            }

            this.$router.back(-1);
        },
        changeLevel(row) {
            this.dataForm.level += 1

            if (this.dataForm.level === 2) {
                this.dataForm.zhen = row.area
                this.mixinViewModuleOptions.getDataListURL = '/task/cunResultList'
            } else {
                this.dataForm.cun = row.area
                this.mixinViewModuleOptions.getDataListURL = '/task/resultList'
                this.mixinViewModuleOptions.getDataListIsPage = true
            }

            this.query()
        }
    },
};
</script>
<style lang="scss" scoped>
.box-card {
    margin-top: 30px;
    height: calc(100vh - 180px);
    overflow-y: scroll;
}
</style>

